export default function getLogsReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_LOGS_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_LOGS_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_LOGS_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}